module.exports = __webpack_public_path__ + "static/media/2 (33).4dae09b9.jpg";